
export * from './global-res-object';